import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import ProfileCard from '../shared/ProfileCard';
import SafePureComponent from '../shared/SafePureComponent';
import ProfileInfo from './ProfileInfo';
import StatsDesc from './StatsDesc';
import Pro from './Pro';

import './style.scss';

const SellerCard = (props) => {
    const {
        description,
        isPro,
        proSubCategories,
        recentDelivery,
        countryCode,
        memberSince,
        responseTime,
        oneLiner,
        ratingsCount,
        rating,
        achievement,
        hasProfilePhoto,
        profilePhoto
    } = props;

    const showPro = isPro && !_.isEmpty(proSubCategories);

    return (
        <ProfileCard>
            <div className={classNames('seller-card', { 'pro': isPro })}>
                <ProfileInfo oneLiner={oneLiner}
                    ratingsCount={ratingsCount}
                    rating={rating}
                    achievement={achievement}
                    hasProfilePhoto={hasProfilePhoto}
                    profilePhoto={profilePhoto}/>
                {showPro &&
                    <Pro proSubCategories={proSubCategories}/>
                }
                <StatsDesc description={description}
                    recentDelivery={recentDelivery}
                    countryCode={countryCode}
                    memberSince={memberSince}
                    responseTime={responseTime}/>
            </div>
        </ProfileCard>
    );
};

SellerCard.propTypes = {
    description: PropTypes.string,
    isPro: PropTypes.bool,
    proSubCategories: PropTypes.array,
    recentDelivery: PropTypes.number,
    countryCode: PropTypes.string,
    memberSince: PropTypes.number,
    responseTime: PropTypes.number,
    oneLiner: PropTypes.string,
    ratingsCount: PropTypes.number,
    rating: PropTypes.number,
    achievement: PropTypes.number,
    hasProfilePhoto: PropTypes.bool,
    profilePhoto: PropTypes.string
};

const mapStateToProps = ({ ugc }) => {
    const { sellerCard } = getCurrentContent({ ugc });

    return {
        description: sellerCard.description
    };
};

const ConnectedSellerCard = connect(mapStateToProps)(SellerCard);

export { SellerCard, ConnectedSellerCard };
export default SafePureComponent(ConnectedSellerCard);
